import { Typography } from '@mui/material';
import { colors, fontFamilies } from '../../constants/theme';
import { styled } from '@mui/system';

export const SectionHeading = styled('h2')(({ theme }) => ({
  fontFamily: fontFamilies?.gotham,
  fontWeight: 400,
  fontSize: '50px',
  lineHeight: '58px',
  letterSpacing: '-1.2px',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '40px',
    fontWeight: 300,
    lineHeight: '44px',
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '25px',
    padding: '0 16px',
  },
}));

export const SectionSubtext = styled(Typography)(({ theme, customStyles }) => ({
  fontFamily: fontFamilies?.quicksand,
  fontWeight: 400,
  lineHeight: '32px',
  textAlign: 'center',
  maxWidth: '950px',
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    padding: '0 16px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '22px',
  },
  ...customStyles,
}));

export const DescriptionText = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies?.quicksand || 'Quicksand, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  color: colors.text,
  lineHeight: '100%',
  [theme.breakpoints.up('sm')]: {
    fontSize: '17px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
}));
